import { useEffect, useState } from 'react';
// import { FaChevronDown, FaFilter } from "react-icons/fa";
import { FiSearch, FiSettings } from "react-icons/fi";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { status } from '../../_constants/commonIVY';
import { matterAction } from '../../_actions';
import Sidebar from '../../component/Sidebar';
import Modal from "react-bootstrap/Modal";
import dashboardlogo from "../../utils/images/dashboard-logo.svg";
import adminImage from "../../utils/images/admin_img.png";
import lockicons from "../../utils/images/lock-icons.svg";
import plusicon from "../../utils/images/plus_icon.svg";
import Mattersicon from "../../utils/images/Matters_icon.svg";
import filtericon from "../../utils/images/filter_icon.svg";
import arrow from "../../utils/images/arrow.svg";
// import veiwFile from "../../utils/images/view_icon.svg";
// import closeicon from "../../utils/images/close-icons.svg";
// import Chat from "../Chat";
// import Modal from "react-bootstrap/Modal";


function Dashboard() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState('');
    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);
    const matterData = useSelector((state) => state.matterDetails);
    const [errors, setErrors] = useState({});
    const [matters, setMatters] = useState([]);
    const [createMatter, setCreateMatter] = useState({
        case_id: "",
        client_name: "",
        short_description: "",
        action: "",
        staff_name: "",
    });

    useEffect(() => {
        if (matterData && matterData.matter_status === status.SUCCESS) {
            setMatters(Array.isArray(matterData.matter_data) ? matterData.matter_data : []);
        }
    }, [matterData]);

    useEffect(() => {
        dispatch(matterAction.getMatterDetail());
    }, []);



    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        try {
            await dispatch(matterAction.createMatterDetail(createMatter));
            setTimeout(async () => {
                await dispatch(matterAction.getMatterDetail());
                handleClose();
            }, 500);
            // handleClose();
            // setTimeout(async () => {
            //     await dispatch(matterAction.getMatterDetail());
            //     handleClose();
            // }, 500);
            // handleClose();
            setCreateMatter({
                case_id: "",
                client_name: "",
                short_description: "",
                action: "",
                staff_name: "",
            });
        } catch (error) {
            console.error("Error creating matter:", error);
        }
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setCreateMatter(prev => ({ ...prev, [name]: value }));

        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: "" }));
        }
    };

    const validate = () => {
        const newError = {};

        if (!createMatter.case_id)
            newError.case_id = "Case id is required!";
        if (!createMatter.client_name.trim())
            newError.client_name = "Client Name is required!";
        if (!createMatter.short_description)
            newError.short_description = "Short description is required!";
        if (!createMatter.action)
            newError.action = "Please choose any action";
        if (!createMatter.staff_name.trim()) newError.staff_name = "Staff Name is required!";

        setErrors(newError);
        return Object.keys(newError).length === 0;
    };
    const handleClose = () => {
        setShow(false);
        setCreateMatter({
            case_id: "",
            client_name: "",
            short_description: "",
            action: "",
            staff_name: "",
        });
        setErrors({});
    };


    const filteredMatters = matters.filter(matter => {
        if (!search) return true;
        const searchTerm = search.toLowerCase();
        return (
            matter.client_name.toLowerCase().includes(searchTerm) ||
            matter.case_id.toLowerCase().includes(searchTerm) ||
            matter.short_description.toLowerCase().includes(searchTerm) ||
            matter.staff_name.toLowerCase().includes(searchTerm) ||
            matter.action.toLowerCase().includes(searchTerm)
        );
    });


    const handleRowClick = (id) => {
        if (id) {
            navigate(`/matter-details/${id}`);
        } else {
            console.warn("Matter ID is undefined. Please try again.");
        }
    };


    return (
        <div className="main-wrapper-dashboard">
            <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />

            <div className='right-dashboard'>
                <div className={`dashboard-screen ${isOpen ? 'main-content-width' : 'main-content-small-width'}`}>
                    <div className="dashboard-header">
                        <div className="dashboard-search">
                            <div className="dashboard-logo">
                                {!isOpen && <img src={dashboardlogo} alt='' className="show-img" />}
                            </div>
                            <div className="search-bar">
                                <FiSearch className='search-icon' />
                                <input
                                    type="text"
                                    placeholder="Search current matters..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    className="form-control"
                                />
                            </div>
                            <span className="text-search">Advanced Search</span>
                        </div>
                        <div className="dashboard-button">
                            <button className="new-matter primary-btn" onClick={handleShow}>
                                <img src={plusicon} alt='' /> New Matter
                            </button>
                            <button className="group-matter primary-btn">
                                <img src={Mattersicon} alt='' className='menu-icon' /> Group Matters <img src={arrow} alt='' className="text-xs" />
                            </button>
                            <button className="current-matter primary-btn">
                                <img src={filtericon} alt='' className='menu-icon' /> Current Matters <img src={arrow} alt='' className="text-xs" />
                            </button>
                        </div>
                    </div>

                    <div className="overflow-x-auto">
                        <table className="table-auto">
                            <thead>
                                <tr className='table-top'>
                                    <th className="py-2 text-left whitespace-nowrap">No.</th>
                                    <th className="px-4 py-2 text-left2">Client & Details</th>
                                    <th className="px-4 py-2 text-left3">Correspondence</th>
                                    <th className="px-4 py-2 text-left4">Action</th>
                                    <th className="px-4 py-2 text-right">
                                        <FiSettings className="inline-block text-gray-600" />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredMatters && filteredMatters.length > 0 ? (
                                    filteredMatters
                                        .filter(item => item?._id)
                                        .map((item, index) => (
                                            <tr key={index} className="bg-white w-full max-w-full" onClick={() => handleRowClick(item._id)}>
                                                <td className="user-content">
                                                    <div className="lock-bg">
                                                        {!isOpen && <div className="lock-img-show">
                                                            <img src={lockicons} alt='' /></div>}
                                                    </div>
                                                    <span>{item?.case_id}</span>
                                                    <div className='name-middle'>
                                                        <h3>{item?.client_name}</h3>
                                                        <p>{item?.short_description}</p>
                                                    </div>
                                                </td>
                                                <td className="admin-img items-center">
                                                    <div className="relative">
                                                        <img
                                                            src={adminImage}
                                                            alt=''
                                                            className={`${isOpen ? 'full-img' : 'small-img'}`}
                                                        />
                                                    </div>
                                                    <span className="text-name">{item?.staff_name}</span>
                                                </td>
                                                <td>
                                                    <button
                                                        className={`primary-btn ${item.action === 'TRIAL' ? 'bg-green-500' :
                                                            item.action === 'LIMITED PERIOD EXPIRED' ? 'bg-red-500' :
                                                                item.action === 'IN PROGRESS' ? 'bg-yellow-500' : ''
                                                            }`}
                                                    >
                                                        {item?.action}
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" className="text-center py-4">
                                            {search ? 'No matching matters found' : 'No matters available'}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <p className="show-content">
                        {filteredMatters.length > 0 && `Showing ${filteredMatters.length} matter${filteredMatters.length > 1 ? 's' : ''}`}
                        {search && filteredMatters.length === 0 && 'No results found'}
                    </p>
                </div>
            </div>

            <Modal show={show} onHide={handleClose} className="matter_detail">
                <Modal.Header closeButton>
                    <Modal.Title>Matter Inquiry</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="join-modal">
                        <div className="form-group">
                            <label>Case Id</label>
                            <div className="case-icon" />
                            <input
                                type="text"
                                className={`form-control ${errors.case_id ? 'is-invalid' : ''}`}
                                onChange={handleChange}
                                name="case_id"
                                value={createMatter.case_id}
                            />
                            {errors.case_id && <p style={{ color: "red" }}>{errors.case_id}</p>}
                        </div>

                        <div className="form-group">
                            <label>Client Name</label>
                            <div className="client-icon" />
                            <input
                                type="text"
                                className={`form-control ${errors.client_name ? 'is-invalid' : ''}`}
                                onChange={handleChange}
                                name="client_name"
                                value={createMatter.client_name}
                            />
                            {errors.client_name && <p style={{ color: "red" }}>{errors.client_name}</p>}
                        </div>

                        <div className="form-group">
                            <label>Short Description</label>
                            <div className="phone-icon" />
                            <input
                                type="text"
                                className={`form-control ${errors.short_description ? 'is-invalid' : ''}`}
                                onChange={handleChange}
                                name="short_description"
                                value={createMatter.short_description}
                            />
                            {errors.short_description && <p style={{ color: "red" }}>{errors.short_description}</p>}
                        </div>
                        <div className="form-group">
                            <label>Staff Name</label>
                            <div className="staff-icon" />
                            <input
                                type="text"
                                className={`form-control ${errors.staff_name ? 'is-invalid' : ''}`}
                                name="staff_name"
                                onChange={handleChange}
                                value={createMatter.staff_name}
                            />
                            {errors.staff_name && <p style={{ color: "red" }}>{errors.staff_name}</p>}
                        </div>

                        <div className="form-group">
                            <label>Action</label>
                            <div className={`custom-select-wrapper ${errors.action ? 'is-invalid' : ''}`}>
                                <select
                                    className="custom-select"
                                    name="action"
                                    onChange={handleChange}
                                    value={createMatter.action}
                                >
                                    <option value="">Select Action</option>
                                    <option value="TRIAL">TRIAL</option>
                                    <option value="LIMITED PERIOD EXPIRED">LIMITED PERIOD EXPIRED</option>
                                    <option value="IN PROGRESS">IN PROGRESS</option>
                                </select>
                                {errors.action && <p style={{ color: "red" }}>{errors.action}</p>}
                            </div>
                        </div>
                        <div className="d-flex justify-content-end gap-2 mt-4">
                            <button type="button" className="btn btn-primary btn-secondary" onClick={handleClose}>Cancel</button>
                            <button
                                type="submit"
                                className="btn btn-primary"
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (validate()) {
                                        handleSubmit(e);
                                        // handleClose();       
                                    }
                                }}
                            >
                                Save
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
            {/* <Modal show={showChat} onHide={handleCloseChat} className={`${isFullscreen ? "FullScreenView" : "smallScreenView"
                } chat-modal`}>
                <Modal.Header>
                    <Modal.Title>Ask</Modal.Title>
                    <div className='veiw-file'>
                        <button type="button" className="btn btn-primary btn-secondary">
                            <img
                                src={!isFullscreen ? veiwFile : veiwFile}
                                alt=""
                                className={`${isFullscreen ? "FullScreenView" : "smallScreenView"
                                    }`}
                                onClick={() => setIsFullScreen(!isFullscreen)}
                            />
                        </button>
                        <button closeButton onClick={handleCloseChat}>
                            <img src={closeicon} alt="close" className='close-icon' />
                        </button>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <p className='show-content'>Your personal AI legal assistant</p>
                </Modal.Body>
            </Modal> */}
        </div>
    );
}

export default Dashboard;